import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../data/translations';
import logo from '../assets/images/alitero_ng.webp';

const FooterLink = ({ to, children }) => (
  <Link
    to={to}
    className="relative inline-block text-sm text-stone-300 hover:text-amber-300 transition-colors duration-200 group"
  >
    {children}
    <span className="absolute left-0 right-0 -bottom-1 h-0.5 bg-amber-300 origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-300 ease-out" />
  </Link>
);

const Footer = () => {
  const { currentLanguage } = useLanguage();
  const t = translations[currentLanguage];

  return (
    <footer className="bg-navy-950 pt-0 mt-0">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <motion.div
            whileHover={{ scale: 1.03 }}
            transition={{ type: 'spring', stiffness: 300, damping: 20 }}
            className="flex items-center mb-4 md:mb-0"
          >
            <img
              src={logo}
              alt="Alitero Logo"
              className="h-[60px] w-auto"
            />
          </motion.div>

          <div className="flex flex-col md:flex-row items-center space-y-2 md:space-y-0 md:space-x-6">
            <p className="text-sm text-stone-400">{t.footer.copyright}</p>
            <div className="flex space-x-4">
              <FooterLink to="/privacy">{t.footer.privacy}</FooterLink>
              <FooterLink to="/imprint">{t.footer.imprint}</FooterLink>
              <FooterLink to="/terms">{t.footer.terms}</FooterLink>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
